import React, { useMemo } from "react";
import { Dropdown, getImage } from "@dishopsaas/design-system";
import { Typography, Box } from "@mui/material";
import { CartBadge } from "../CartBadge";
import type {
  UserDropdownOption,
  DropDownProps,
} from "../../../../1_types/InfoBarTypes";
import { MenuRow } from "./MenuRow";
import { useUserDropdown } from "../../../../hooks/useUserDropdown";
import { dropDownContainer, userDropdownRoot } from "../../InfoBar.styles";
import { useTheme, useMediaQuery } from "@mui/material";
import { isQrCode } from "../../../../utils";
import { getLoyaltyCashback } from "../../../Loyalty/Loyalty.services";
export const UserDropdown: React.FC<DropDownProps> = ({
  points = 0,
  nbCommande,
  styles,
  handlers,
  width,
  loyalty,
}) => {
  const { userName, email, goToHome, menuConfig } = useUserDropdown();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const dynamicGap = isTablet ? 2 : 4;
  const options: UserDropdownOption[] = useMemo(
    () => [
      {
        value: "profile",
        label: userName,
        leftIcon: "CircleUser",
        description:
          points && !getLoyaltyCashback(loyalty) ? (
            <Box sx={{ display: "flex", alignItems: "center", ml: "-2.5px" }}>
              {getImage("loyalty", { size: 18 })}
              <Typography
                variant="caption"
                sx={{ color: theme.palette.primary.main }}
              >
                {points} points
              </Typography>
            </Box>
          ) : undefined,
      },
    ],
    [userName, points],
  );

  return (
    <Box
      sx={{
        ...userDropdownRoot,
        width: { md: width },
        gap: dynamicGap,
      }}
    >
      <CartBadge count={nbCommande} onClick={handlers.handleCartClick} />
      {!isQrCode() && (
        <div style={styles.dropdownWrapper}>
          <Box sx={dropDownContainer}>
            <Dropdown
              value={options[0].value}
              options={options}
              withoutBorder
              withDesecription
              menuItemSx={{ border: "none", boxShadow: 1 }}
              renderOpenContent={({ close }) => (
                <Box>
                  <MenuRow
                    label={userName}
                    icon="CircleUser"
                    height="60px"
                    subLabel={email}
                    path="/"
                    onClick={() => goToHome(close)}
                  />

                  {menuConfig
                    .filter((i, index) => index !== 0)
                    .map((item) => (
                      <MenuRow
                        key={item.label}
                        label={item.label}
                        icon={item.icon}
                        path={item.path}
                        onClick={() => item.action(close)}
                        color={item.color}
                      />
                    ))}
                </Box>
              )}
            />
          </Box>
        </div>
      )}
    </Box>
  );
};
